import { render } from "./FormDetailsModal.vue?vue&type=template&id=1640cc65&scoped=true"
import script from "./FormDetailsModal.vue?vue&type=script&lang=js"
export * from "./FormDetailsModal.vue?vue&type=script&lang=js"

import "./FormDetailsModal.vue?vue&type=style&index=0&id=1640cc65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1640cc65"]])

export default __exports__